<template>
  <section class="finish-message">
    <v-icon
      class="finish-message__icon"
      color="green"
    >
      check_circle
    </v-icon>
    <h2 class="finish-message__title">
      Pedido <strong>{{ solicitationId }}</strong> gerado com sucesso, aguardando análise
    </h2>
    <router-link
      to="/"
      title="Retornar a página inicial"
      class="finish-message__button"
    >
      Retornar a página inicial
    </router-link>
  </section>
</template>

<script>
// Vuex Store - Sit Pedidos (mapping actions and states)
// import { mapState } from "vuex";
// const state = mapState('sitPedidos', ['form'])

export default {
  name: 'FinishMessage',

  props: {
    solicitationId: {
      type: Number,
      default: () => null
    }
  },

  computed: {
    // ...state,

    // solicitationId: {
    //   get() { return this.form.pedido ? this.form.pedido.id : '' }
    // }
  }
}
</script>

<style lang="scss" scoped>
.finish-message {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__icon {
    font-size: 60px;
  }

  &__title {
    font-weight: 400;
    margin: 10px auto;
  }

  &_button {
    margin-bottom: 40px;
  }
}
</style>
